/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.1
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * filter operation for date time document metadata
 */
export type FilterDocumentMetadataDateTimeOperationEnum = 'EQUAL' | 'NOT_EQUAL' | 'LESS' | 'LESS_OR_EQUAL' | 'GREATER' | 'GREATER_OR_EQUAL' | 'BETWEEN' | 'NOT_BETWEEN';

export const FilterDocumentMetadataDateTimeOperationEnum = {
	EQUAL: '=' as FilterDocumentMetadataDateTimeOperationEnum,
	NOT_EQUAL: '!=' as FilterDocumentMetadataDateTimeOperationEnum,
	LESS: '<' as FilterDocumentMetadataDateTimeOperationEnum,
	LESS_OR_EQUAL: '<=' as FilterDocumentMetadataDateTimeOperationEnum,
	GREATER: '>' as FilterDocumentMetadataDateTimeOperationEnum,
	GREATER_OR_EQUAL: '=>' as FilterDocumentMetadataDateTimeOperationEnum,
	BETWEEN: 'ZWISCHEN' as FilterDocumentMetadataDateTimeOperationEnum,
	NOT_BETWEEN: 'NICHT ZWWISCHEN' as FilterDocumentMetadataDateTimeOperationEnum
};
